"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSocialCreditCodeExists = checkSocialCreditCodeExists;
exports.checkUnionNameExists = checkUnionNameExists;
exports.unionBatchDelete = unionBatchDelete;
exports.unionBatchDisable = unionBatchDisable;
exports.unionBatchEnable = unionBatchEnable;
exports.unionBatchUpdate = unionBatchUpdate;
exports.unionCreate = unionCreate;
exports.unionDelete = unionDelete;
exports.unionDetail = unionDetail;
exports.unionExport = unionExport;
exports.unionGetTemplate = unionGetTemplate;
exports.unionImport = unionImport;
exports.unionList = unionList;
exports.unionMemberBatchDelete = unionMemberBatchDelete;
exports.unionMemberBatchDisable = unionMemberBatchDisable;
exports.unionMemberBatchEnable = unionMemberBatchEnable;
exports.unionMemberBatchUpdate = unionMemberBatchUpdate;
exports.unionMemberCreate = unionMemberCreate;
exports.unionMemberDelete = unionMemberDelete;
exports.unionMemberDetail = unionMemberDetail;
exports.unionMemberExport = unionMemberExport;
exports.unionMemberGetTemplate = unionMemberGetTemplate;
exports.unionMemberImport = unionMemberImport;
exports.unionMemberList = unionMemberList;
exports.unionMemberStatistics = unionMemberStatistics;
exports.unionMemberUpdate = unionMemberUpdate;
exports.unionStatistics = unionStatistics;
exports.unionUpdate = unionUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 工会信息
function unionList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/list',
    method: 'GET',
    params: params
  });
}
function unionDetail(id) {
  return (0, _request.default)({
    url: "/admin/union/detail/".concat(id),
    method: 'GET'
  });
}
function unionCreate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/create',
    method: 'POST',
    data: data
  });
}
function unionUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/union/update/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
function unionDelete(id) {
  return (0, _request.default)({
    url: "/admin/union/delete/".concat(id),
    method: 'DELETE'
  });
}
function unionBatchDelete(ids) {
  return (0, _request.default)({
    url: '/admin/union/batch/delete',
    method: 'DELETE',
    data: ids
  });
}
function unionBatchUpdate(data) {
  return (0, _request.default)({
    url: '/admin/union/batch/update',
    method: 'PUT',
    data: data
  });
}
function unionBatchEnable(ids) {
  return (0, _request.default)({
    url: '/admin/union/batch/enable',
    method: 'PUT',
    data: ids
  });
}
function unionBatchDisable(ids) {
  return (0, _request.default)({
    url: '/admin/union/batch/disable',
    method: 'PUT',
    data: ids
  });
}
function unionExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/export',
    method: 'GET',
    params: params
  });
}
function unionImport(formData) {
  return (0, _request.default)({
    url: '/admin/union/import',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
function unionGetTemplate() {
  return (0, _request.default)({
    url: '/admin/union/template',
    method: 'GET'
  });
}

// 工会会员 (后端支持 /admin/union/user 和 /admin/union/member 两个路径)
function unionMemberList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/user/list',
    method: 'GET',
    params: params
  });
}
function unionMemberDetail(id) {
  return (0, _request.default)({
    url: "/admin/union/user/detail/".concat(id),
    method: 'GET'
  });
}
function unionMemberCreate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/user/create',
    method: 'POST',
    data: data
  });
}
function unionMemberUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/union/user/update/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
function unionMemberDelete(id) {
  return (0, _request.default)({
    url: "/admin/union/user/delete/".concat(id),
    method: 'DELETE'
  });
}
function unionMemberBatchDelete(ids) {
  return (0, _request.default)({
    url: '/admin/union/user/batch/delete',
    method: 'DELETE',
    data: ids
  });
}
function unionMemberBatchUpdate(data) {
  return (0, _request.default)({
    url: '/admin/union/user/batch/update',
    method: 'PUT',
    data: data
  });
}
function unionMemberBatchEnable(ids) {
  return (0, _request.default)({
    url: '/admin/union/user/batch/enable',
    method: 'PUT',
    data: ids
  });
}
function unionMemberBatchDisable(ids) {
  return (0, _request.default)({
    url: '/admin/union/user/batch/disable',
    method: 'PUT',
    data: ids
  });
}
function unionMemberImport(formData) {
  return (0, _request.default)({
    url: '/admin/union/user/import',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
function unionMemberExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/union/user/export',
    method: 'GET',
    params: params
  });
}
function unionMemberGetTemplate() {
  return (0, _request.default)({
    url: '/admin/union/user/template',
    method: 'GET'
  });
}

// 统计信息
function unionStatistics() {
  return (0, _request.default)({
    url: '/admin/union/statistics',
    method: 'GET'
  });
}

// 验证工会名称是否重复
function checkUnionNameExists(name) {
  var excludeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = {
    name: name
  };
  if (excludeId) {
    params.excludeId = excludeId;
  }
  return (0, _request.default)({
    url: '/admin/union/check/name',
    method: 'GET',
    params: params
  });
}

// 验证社会信用代码是否重复
function checkSocialCreditCodeExists(socialCreditCode) {
  var excludeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = {
    socialCreditCode: socialCreditCode
  };
  if (excludeId) {
    params.excludeId = excludeId;
  }
  return (0, _request.default)({
    url: '/admin/union/check/socialCreditCode',
    method: 'GET',
    params: params
  });
}
function unionMemberStatistics(unionId) {
  var params = unionId ? {
    unionId: unionId
  } : {};
  return (0, _request.default)({
    url: '/admin/union/user/statistics',
    method: 'GET',
    params: params
  });
}